// extracted by mini-css-extract-plugin
export default {"wrap":"OptionButton_wrap__3wx4d","button":"OptionButton_button__rz2n2","active":"OptionButton_active__XCOSi"};